const { icons } = require('./constant');

const templates = {
	id: 'templates_master',
	title: 'Templates',
	type: 'collapse',
	icon: icons.IconBranch,
	children: [
		{
			id: 'template_codes',
			title: 'Template Codes',
			type: 'item',
			url: '/templateCodes',
			icon: icons.TranslateOutlinedIcon,
			breadcrumbs: true,
		},
	],
};

export default templates;
